export default {
  WEBSITE: {
    INDEX: {
      PATH: '/b/:businessSlug/website',
      NAME: 'website',
    },
  },
}
